import { fmtEUR, fmtDate } from "@/lib/api";
import { shortConcept } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { KIND_LABELS, SortableHead } from "./shared";

export function CategorizedTable({ rows, totalCount, canAct, focusTx, sort, clickSort, onUncategorize, catName, branchName }) {
  return (
    <Card>
      <CardContent className="p-0">
        <Table>
          <TableHeader>
            <TableRow>
              <SortableHead label="Fecha" sortKey="date" defDir="desc" sort={sort} clickSort={clickSort} testid="recon-sort-cat-date" />
              <SortableHead label="Concepto" sortKey="concept" sort={sort} clickSort={clickSort} testid="recon-sort-cat-concept" />
              <SortableHead label="Tipo" sortKey="kind" sort={sort} clickSort={clickSort} testid="recon-sort-cat-kind" />
              <SortableHead label="Categoría / Sucursal" sortKey="catbranch" sort={sort} clickSort={clickSort} testid="recon-sort-cat-catbranch" />
              <SortableHead label="Importe" sortKey="amount" sort={sort} clickSort={clickSort} testid="recon-sort-cat-amount" right />
              <TableHead className="text-right"></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((tx) => (
              <TableRow key={tx.id} data-testid={`recon-categorized-${tx.id}`}
                className={tx.id === focusTx ? "bg-amber-50 ring-1 ring-amber-300" : undefined}>
                <TableCell className="text-sm whitespace-nowrap">{fmtDate(tx.date)}</TableCell>
                <TableCell className="text-sm max-w-72 truncate" title={tx.concept}>{shortConcept(tx.concept)}</TableCell>
                <TableCell><Badge variant="outline" className="text-blue-700 border-blue-200 bg-blue-50">{KIND_LABELS[tx.pnl_kind] || tx.pnl_kind}</Badge></TableCell>
                <TableCell className="text-xs text-slate-600">
                  {catName(tx.pnl_category_id)}{tx.branch_id ? `${catName(tx.pnl_category_id) ? " · " : ""}${branchName(tx.branch_id)}` : ""}
                </TableCell>
                <TableCell className={`text-right font-num font-semibold ${tx.amount >= 0 ? "text-green-700" : "text-red-700"}`}>{fmtEUR(tx.amount)}</TableCell>
                <TableCell className="text-right">
                  {canAct && (
                    <Button data-testid={`recon-uncategorize-${tx.id}`} size="sm" variant="outline" onClick={() => onUncategorize(tx.id)}>Deshacer</Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
            {rows.length === 0 && (
              <TableRow><TableCell colSpan={6} className="text-center py-10 text-slate-400 text-sm">
                {totalCount === 0 ? "No hay movimientos categorizados." : "Ningún categorizado coincide con la búsqueda."}
              </TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
